import { render, staticRenderFns } from "./ResourceAvailabilityReport.vue?vue&type=template&id=54b0c659&"
import script from "./ResourceAvailabilityReport.vue?vue&type=script&lang=js&"
export * from "./ResourceAvailabilityReport.vue?vue&type=script&lang=js&"
import style0 from "./ResourceAvailabilityReport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports